import ApplicationController from '../../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'directions',
    'futureRepeats',
    'input',
    'repeats',
    'showLess',
    'showMore',
    'totalRepeats'
  ]

  static classes = [
    'hide'
  ]

  connect() {
    this.toggleRepeats()
  }

  // ==== Getters

  // ==== Setters

  // ==== Actions

  toggleRepeats() {
    if (this.hasTotalRepeatsTarget && this.hasFutureRepeatsTarget) {
      const hideTotal = this.inputTarget.checked
      this.totalRepeatsTarget.classList.toggle(this.hideClass, hideTotal)
      this.futureRepeatsTarget.classList.toggle(this.hideClass, !hideTotal)
    }
  }

  showMore() {
    this.#show()
  }

  showLess() {
    this.#show(false)
  }

  // ==== Private

  #show(more = true) {
    this.showMoreTarget.classList.toggle(this.hideClass, more)
    this.showLessTarget.classList.toggle(this.hideClass, !more)
    this.directionsTarget.classList.toggle(this.hideClass, !more)
  }

  // ==== Channels

}
